import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  public isAuthorized: boolean;
  public userData: any;
  private headers: Headers;
  private authenticationSource = new Subject<boolean>();

  constructor(
    private _router: Router,
    private sessionService: SessionService
  ) {
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');

    if (this.sessionService.getItem('IsAuthorized') !== '') {
      this.isAuthorized = this.sessionService.getItem('IsAuthorized');
      this.authenticationSource.next(true);
      this.userData = this.sessionService.getItem('userData');
    }
  }

  public GetToken(): any {
    return this.sessionService.getItem('authorizationData');
  }

  public ResetAuthorizationData() {
    this.sessionService.setItem('authorizationData', '');
    this.isAuthorized = false;
    this.sessionService.setItem('IsAuthorized', false);
  }

  public SetAuthorizationData(token: any, userName: string) {
    if (this.sessionService.getItem('authorizationData') !== '') {
      this.sessionService.setItem('authorizationData', '');
    }
    this.sessionService.setItem('loggedInUser', userName);
    this.sessionService.setItem('authorizationData', token);
    this.isAuthorized = true;
    this.sessionService.setItem('IsAuthorized', true);
  }

  public AuthorizedCallback() {
    this.ResetAuthorizationData();
  }

  public Logoff() {
    this.ResetAuthorizationData();

    // emit observable
    this.authenticationSource.next(false);
  }

  public HandleError(error: any) {
    if (error.status === 403) {
      this._router.navigate(['/Forbidden']);
    } else if (error.status === 401) {
      this._router.navigate(['/Unauthorized']);
    }
  }
}
